import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { ProveedorDeAvisos } from './avisos';
import { ProveedorDeIdioma } from './i18n';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('Falta el elemento #root en index.html.');

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      {/*
        Los avisos envuelven a toda la aplicación, no a cada pantalla: el que sale al pulsar
        «Crear» tiene que seguir visible si la acción navega a otra ruta.
      */}
      {/*
        El idioma va por fuera de los avisos: un error que aparece mientras alguien cambia el
        selector tiene que salir en el idioma nuevo, no en el que estaba cuando se montó.
      */}
      <ProveedorDeIdioma>
        <ProveedorDeAvisos>
          <App />
        </ProveedorDeAvisos>
      </ProveedorDeIdioma>
    </BrowserRouter>
  </StrictMode>,
);
